import axios from 'axios';

const ajaxBase = (httpType) => (_loadType, ajaxObj) => {
  axios[httpType](ajaxObj.path, ajaxObj.form || {})
    .then((response) => {
      if (response.data) {
        ajaxObj.succcess(response.data);
      } else {
        console.log('JSON ERROR', response);
      }
    })
    .catch((error) => {
      console.log(error);
    });
};
const ajax = {
  get: ajaxBase('get'),
  post: ajaxBase('post'),
  put: ajaxBase('put'),
};

const roomActions = (dispatch) => {
  return {
    loadRoomDetail: (id) => {
      dispatch({ type: 'ROOM_LOAD' });
      axios
        .get(`/api/visitor/rooms/${id}`, {})
        .then((response) => {
          if (response.data) {
            dispatch({ type: 'ROOM_SUCCESS', room: response.data });
          } else {
            dispatch({ type: 'ROOM_ERROR', error: 'Wrong format' });
          }
        })
        .catch((error) => {
          if (error.response.status === 403) {
            dispatch({ type: 'ROOM_NO_TICKET' });
          }
          dispatch({ type: 'ROOM_ERROR', error: 'Could not load room' });
        });
    },

    loadBackstageRoomDetail: (id) => {
      dispatch({ type: 'ROOM_LOAD' });
      axios
        .get(`/api/visitor/backstagerooms/${id}`, {})
        .then((response) => {
          dispatch({ type: 'ROOM_SUCCESS', room: response.data });
        })
        .catch(() => {
          dispatch({ type: 'ROOM_ERROR', error: 'Could not load room' });
        });
    },

    reloadRoomDetail: (id) => {
      dispatch({ type: 'RELOAD_LOAD' });
      axios
        .get(`/api/visitor/rooms/${id}`, {})
        .then((response) => {
          if (response.data) {
            dispatch({ type: 'ROOM_SUCCESS', room: response.data });
          } else {
            dispatch({ type: 'ROOM_ERROR', error: 'Wrong format' });
          }
        })
        .catch((error) => {
          console.log('ROOM ERROR', error);
          dispatch({ type: 'ROOM_ERROR', error: 'Could not load room' });
        });
    },
    loadModeratorRoomMessages: (id) => {
      dispatch({ type: 'ROOM_LOAD' });
      axios
        .get(`/api/visitor/rooms/${id}/moderatormessages`, {})
        .then((response) => {
          dispatch({ type: 'ROOM_SUCCESS', room: response.data });
        })
        .catch((error) => {
          dispatch({ type: 'ROOM_ERROR', error: error });
        });
    },
    loadRoomAskQuestions: (id) => {
      dispatch({ type: 'ROOM_LOAD' });
      axios
        .get(`/api/visitor/rooms/${id}/ask`, {})
        .then((response) => {
          dispatch({ type: 'ROOM_SUCCESS', room: response.data });
        })
        .catch((error) => {
          dispatch({ type: 'ROOM_ERROR', error: error });
        });
    },
    loadModeratorRoomDetail: (id, callback) => {
      dispatch({ type: 'ROOM_LOAD' });
      axios
        .get(`/api/visitor/rooms/${id}/moderator`, {})
        .then((response) => {
          dispatch({ type: 'ROOM_SUCCESS', room: response.data });
          callback && callback();
        })
        .catch((error) => {
          dispatch({ type: 'ROOM_ERROR', error: error });
        });
    },
    loadModeratorRoomPollDetail: (id) => {
      dispatch({ type: 'ROOM_LOAD' });
      axios
        .get(`/api/visitor/rooms/${id}/moderatorpolls`, {})
        .then((response) => {
          dispatch({ type: 'ROOM_SUCCESS', room: response.data });
        })
        .catch((error) => {
          dispatch({ type: 'ROOM_ERROR', error: error });
        });
    },
    setCurrentPoll: (roomId, pollId, show) => {
      dispatch({ type: 'CURRENT_POLL_UPDATE' });
      axios
        .put(`/api/visitor/rooms/${roomId}/currentpoll`, {
          pollId: pollId,
          show: show,
        })
        .then((response) => {
          dispatch({
            type: 'CURRENT_POLL_UPDATE_SUCCESS',
            poll: response.data.poll,
          });
        })
        .catch((error) => {
          dispatch({ type: 'CURRENT_POLL_ERROR', error: error });
        });
    },
    setDisplayPoll: (roomId, pollId, show) => {
      axios
        .put(`/api/visitor/rooms/${roomId}/displaypoll`, {
          pollId: pollId,
          show: show,
        })
        .then((response) => {
          dispatch({
            type: 'DISPLAY_POLL_UPDATE_SUCCESS',
            poll: response.data.poll,
          });
        })
        .catch(() => {});
    },
    setMessagePinned: (msgId, pinned) => {
      axios
        .put(`/api/visitor/messages/${msgId}/pin`, {
          pinned,
        })
        .then((response) => {
          dispatch({
            type: 'ROOM_MSG_PINNED',
            msg: response.data,
          });
        })
        .catch((error) => {
          console.log('Could not pin', error);
        });
    },
    setModeratorView: (roomId, moderator_view) => {
      ajax.put(
        null,
        {
          path: `/api/visitor/rooms/${roomId}/moderatorview`,
          form: { moderator_view },
          succcess: (data) =>
            dispatch({
              type: 'MODERATOR_VIEW_UPDATED',
              moderator_view: data.moderator_view,
            }),
        },
        null
      );
    },
    addTimeReaction: (roomId) => {
      dispatch({ type: 'REACTION_PROGRESS' });
      axios
        .post(`/api/visitor/rooms/${roomId}/timereaction`, {})
        .then((response) => {
          dispatch({ type: 'REACTION_SUCCESS', reaction: response.data });
        })
        .catch((error) => {
          console.log('addTimeReaction error', error);
          dispatch({ type: 'REACTION_ERROR', error: error });
        });
    },
  };
};
export default roomActions;
